import React, { ReactElement, useMemo } from "react";
import { mandateContext } from "../../../../hooks/datatabs";
import AuditTrail from "../../../../components/audittrail/audittrail";

function MandateAuditTrail(): ReactElement {
  const data = mandateContext();
  const entityId = useMemo(() => data?._id || null, [data?._id]);

  return (
    <>
      { data?._id && entityId &&
        <AuditTrail entityType='mandate' id={entityId || ''} />
      }
    </>
  );
}

export default MandateAuditTrail;